<compartido-ficha [configuracion]="configFicha">
  <compartido-tabla-asincrona
    #tabla
    class="tabla {{ responsiveService.claseCSS$ | async }}"
    [dataSource]="dataSource"
    [configuracion]="configTabla"
    (clickAccion)="descargarEtiqueta($event.fila['id'])"
    (clickBoton)="
      $event === 'etiquetas' ? descargarEtiquetas$() : descargarOrdenes$()
    "
  ></compartido-tabla-asincrona>

  <div class="resumen">
    <p>
      Impresas:
      <span *ngIf="!cargando()"> {{ generadas() }} / {{ total() }} </span>
      <mat-spinner
        *ngIf="cargando()"
        diameter="13"
        class="cargando"
      ></mat-spinner>
    </p>
  </div>
</compartido-ficha>
